import { NgModule } from '@angular/core';
import { PreloadAllModules, Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './_service/authguard.service';

import { PanelComponent } from './panel/panel.component';
import { SupplierComponent } from './supplier/supplier.component';
import { SupplierGroupComponent } from './supplier-group/supplier-group.component';
import { SupplierGroupDetailsComponent } from './supplier-group-details/supplier-group-details.component';
import { CompanyComponent } from './company/company.component';
import { CompanyDetailsComponent } from './company-details/company-details.component';
import { SitesComponent } from './sites/sites.component';
import { BvdComponent } from './bvd/bvd.component';
import { ContactsComponent } from './contacts/contacts.component';
import { SiteDetailsComponent } from './site-details/site-details.component';
import { WorkflowComponent } from './workflow/workflow.component';
import { OrbisComponent } from './orbis/orbis.component';
import { AdministrationComponent } from './administration/administration.component';
import { OidcCallBackComponent } from './oidc-call-back/oidc-call-back.component';
import { LogoutComponent } from './logout/logout.component';

const routes: Routes = [
  { path: '', redirectTo: 'sites', pathMatch: 'full' },
  { path: 'panel', component: PanelComponent, data: { page_title: 'LAUNCHPAD' }, canActivate: [AuthGuard] },
  { path: 'supplier', component: SupplierComponent, data: { page_title: 'ISA - MANAGE SUPPLIER DATA' }, canActivate: [AuthGuard] },
  { path: 'supplier-group', component: SupplierGroupComponent, data: { page_title: 'ISA - MANAGE SUPPLIER GROUP DATA' }, canActivate: [AuthGuard] },
  { path: 'supplier-group-details/:row_id', component: SupplierGroupDetailsComponent, data: { page_title: 'ISA - MANAGE SUPPLIER GROUP DATA' }, canActivate: [AuthGuard] },
  { path: 'company', component: CompanyComponent, data: { page_title: 'ISA - MANAGE COMPANY DATA' }, canActivate: [AuthGuard] },
  { path: 'company-details/:row_id', component: CompanyDetailsComponent, data: { page_title: 'ISA - MANAGE Company DATA' }, canActivate: [AuthGuard], runGuardsAndResolvers: 'always' },
  { path: 'sites', component: SitesComponent, data: { page_title: 'ISA - MANAGE SITE DATA' }, canActivate: [AuthGuard] },
  { path: 'site-details/:row_id/:companyId', component: SiteDetailsComponent, data: { page_title: 'ISA - MANAGE SITE DETAILS' }, canActivate: [AuthGuard], runGuardsAndResolvers: 'always' },
  { path: 'bvd', component: BvdComponent, data: { page_title: 'LAUNCHPAD' }, canActivate: [AuthGuard] },
  { path: 'contacts', component: ContactsComponent, data: { page_title: 'ISA - Contacts' }, canActivate: [AuthGuard] },
  { path: 'workflow', component: WorkflowComponent, data: { page_title: 'ISA - Workflow' }, canActivate: [AuthGuard] },
  { path: 'orbis', component: OrbisComponent, data: { page_title: 'ISA - Orbis' }, canActivate: [AuthGuard] },
  { path: 'administration', component: AdministrationComponent, data: { page_title: 'ISA - Admin' }, canActivate: [AuthGuard] },
  { path: 'auth/oidc', component: OidcCallBackComponent, canActivate: [AuthGuard] },
  { path: 'logout', component: LogoutComponent },
  { path: '**', redirectTo: 'sites', pathMatch: 'full' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
